/**
 * Nutrition Progress engine — public barrel.
 *
 * Pure, portable functions (no React / Rill). Built incrementally per block:
 * this first slice powers the persistent headers (range controls, plan status,
 * feature flags). Roll-ups, series, insights and projections land in later
 * modules under the same folder.
 */

export {
  adhColor,
  avgOf,
  band,
  dayAdherence,
  dayDeviation,
  kcalFromMacros,
  macroAdhPct,
  macroCol,
  weekdayGroups,
  weekGroups,
} from "./adherence";
export {
  buildChartSeries,
  buildEnergyExpenditureStats,
  buildGoalData,
  buildGoalProjectionSeries,
  buildMacroAdherenceTable,
  buildMacroBreakdownSeries,
  buildOverUnderSeries,
  buildSummaryStats,
  buildWeekdayAdherenceSeries,
  OVER_UNDER_METRICS,
  overUnderAxisMax,
  resolveActiveBodyweightGoal,
  resolveCustomGoals,
  resolveDailyTargetGoals,
  suggestedIntakeFor,
  weightSlopePerDay,
} from "./analysis";
export {
  ACTIVITY_MULTIPLIERS,
  calculateBmr,
  calculateTdee,
} from "./bmrCalculator";
export { buildBodyweightTrend } from "./bodyweightTrend";
export {
  ADHERENCE_THRESHOLDS,
  BODYWEIGHT_QUICK_RANGES,
  DEFAULT_BODYWEIGHT_QUICK_RANGE,
  DEFAULT_QUICK_RANGE,
  GOAL_DIRECTION_THRESHOLD_KG,
  OFF_TREND_MIN_PRIOR,
  OFF_TREND_PCT,
  ON_PACE_TOLERANCE_KG,
  PLAN_STATUS,
  PROJECTION_MAX_STALE_DAYS,
  QUICK_RANGES,
  RATE_SLOW_MAX_KG_PER_WEEK,
  RATE_STEADY_KG_PER_WEEK,
  RATE_WINDOW_DAYS,
  STALE_WEIGHIN_DAYS,
  TREND_WINDOW_DAYS,
} from "./constants";

export {
  buildPhaseSpans,
  currentNutritionPhase,
  currentTrainingPhase,
  mostRecentPlan,
  planForUtcDate,
  plansInRange,
  rangeFromPlan,
  resolveQuickRange,
  toUtcNumber,
  utcToDate,
} from "./dateRange";
export {
  buildDayRows,
  buildPeriodDatesSet,
  MACROS,
  resolveFoodLogSource,
} from "./dayData";
export { buildInsights } from "./insights";
export { buildWeekDaySlots } from "./logWeekDays";
export {
  getPlanTargetsSummary,
  hasAnnualPlanner,
  hasMealPlan,
  hasRestTargets,
  planMatchesStatusFilter,
  resolvePlanStatus,
  resolvePlanStatusForPlan,
} from "./planStatus";
